import GcCard from '../GcCard/index.vue';

export default {
  name: 'GcCardContainer',
  components: {
    GcCard,
  },
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    width: {
      type: String,
      default: 'half',
    },
    imageOnly: {
      type: Boolean,
      default: true,
    },
    cards: {
      type: Array,
      default: null,
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
